import {
	SET_QUERY,
    SEARCH,
} from '../actions/search';

const initialState = {
    open: false,
    query: '',
    results: [],
};

export default function search(state = initialState, action) {
    switch (action.type) {

    case SEARCH.SUCCESS:
        return Object.assign({}, state, {
            results: action.payload,
        });

    case SET_QUERY:
        return Object.assign({}, state, {
            query: action.query,
            results: action.query.length === 0 ? [] : state.results,
            open: action.query.length > 0,
        });


    default:
        return state;
    }
}



/** WEBPACK FOOTER **
 ** /src/shared/redux/search.js
 **/